/* RESPONSIBLE TEAM: team-inbox */

import Route from '@ember/routing/route';
import type SearchController from 'embercom/controllers/inbox/workspace/inbox/search';

export default class Inbox2SearchRoute extends Route {
  queryParams = {
    query: {
      refreshModel: true,
    },
    filters: {
      refreshModel: true,
    },
    sort: {
      refreshModel: true,
    },
    monitor: {
      refreshModel: true,
    },
    qa_mode: {
      refreshModel: true,
    },
  };

  model() {
    return this.paramsFor(this.routeName);
  }

  resetController(controller: SearchController, isExiting: boolean) {
    if (isExiting) {
      controller.qa_mode = undefined;
    }
  }
}
